import Vue from "vue";
import App from "./App.vue";
import "@/config/permission";
import "@/utils/errorLog";
import "./plugins";
import "@/styles/vab.scss";
import store from "./store";
import router from "./router";
import axios from "axios";
import settingHelp from "@/config/localSetting";
import localSetting from "@/config/settings";
import { resetRemoteRequest } from "@/utils/remoteRequest";
import { resetRequest } from "@/utils/request";
import clipboard2 from "vue-clipboard2";

Vue.config.productionTip = false;
Vue.use(clipboard2);

function initVue() {
  new Vue({
    el: "#app",
    router,
    store,
    render: (h) => h(App),
  });
}

if (process.env.NODE_ENV === "development") {
  settingHelp.setConfig(localSetting);
  initVue();
} else {
  axios
    .get("dynamicConfig.json")
    .then(function (response) {
      settingHelp.setConfig(response.data);
      resetRemoteRequest();
      resetRequest();
      initVue();
    })
    .catch(function (error) {
      console.log(error);
    });
}
